import { CopyIconButton } from '@components/button';
import { Image } from '@components/image';
import { Group } from '@components/layout';
import { DateAndUserDisplay, DateToNowDisplay, Typography } from '@components/typography';
import { Graph } from '@generated/graphql';
import { Box, TableCell } from '@mui/material';
import { memo } from 'react';
import { GraphsListViewPreviewMenu } from './GraphsListViewPreviewMenu';

interface GraphsListViewRowProps {
  graph: Graph;
  refetch: () => void;
}

export const GraphsListViewRow = memo(({ graph, refetch }: GraphsListViewRowProps) => {
  return (
    <>
      <TableCell sx={{ width: '48px' }}>
        <Image
          alt="graph thumbnail"
          url={graph.thumbnail}
          style={{ height: '48px', width: '48px' }}
        />
      </TableCell>
      <TableCell className="row-id-cell">
        <Group gap={1} alignItems="center">
          <Box className="row-id-cell-icon">
            <CopyIconButton
              value={graph?.graphId}
              tooltipProps={{ enterDelay: 500, enterNextDelay: 500 }}
              showValue
            />
          </Box>
          <Typography variant="body2" handleOverFlow width="80%">
            {graph?.name || '-'}
          </Typography>
        </Group>
      </TableCell>
      <TableCell>
        <Typography variant="body2" pr={4} handleOverFlow>
          {graph.description}
        </Typography>
      </TableCell>
      <TableCell>
        <DateAndUserDisplay date={graph.createdAt} user={graph.createdBy} />
      </TableCell>
      <TableCell>
        <DateToNowDisplay date={graph.updatedAt} />
      </TableCell>
      <TableCell>
        <Box display="flex" justifyContent="space-between" alignItems="center" paddingRight="16px">
          <Typography variant="body2">{graph.channel}</Typography>
          <GraphsListViewPreviewMenu graph={graph} refetch={refetch} />
        </Box>
      </TableCell>
    </>
  );
});
